import { render } from "./ProgressaoPeriodo.vue?vue&type=template&id=59e806a5&scoped=true"
import script from "./ProgressaoPeriodo.vue?vue&type=script&lang=js"
export * from "./ProgressaoPeriodo.vue?vue&type=script&lang=js"

import "./ProgressaoPeriodo.vue?vue&type=style&index=0&id=59e806a5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e806a5"]])

export default __exports__